import { render, staticRenderFns } from "./VaCountBadge.demo.vue?vue&type=template&id=1cf1ddbe&scoped=true&"
import script from "./VaCountBadge.demo.vue?vue&type=script&lang=js&"
export * from "./VaCountBadge.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1ddbe",
  null
  
)

export default component.exports